import React from 'react'
import Layout from './Layout'
import t from './translate'
import Application from './Application'
import Debug from './Debug'

function Error ({ message }) {
  return <>{t(message)}</>
}

export default class ApplicationCenter extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      programs: false,
      locations: false,
      contacts: false,
      countries: false,
      healthInsurances: false,
      finished: false,
      failed: false,
    }

    this.loadPrograms()
    this.loadLocations()
    this.loadDefaultContacts()
    this.loadCountries()
  }

  loadPrograms () {
    fetch('/api/application/programs').
      then(response => response.json()).
      then(programs => {
        let mappedPrograms = programs.map((program) => {
          if(program.bezeichnung == 'Mediation') {
            program.remarks = ['Aufbaukurs Familienmediation inkl. Supervision', 'Aufbaukurs Wirtschaftsmediation inkl. Supervision', 'Supervision']
          }

          if(program.bezeichnung == 'Business Coach' || 
             program.bezeichnung == 'Systemischer Business Coach' ||
             program.bezeichnung == 'Systemischer Business Coach - Schwerpunkt Online-Coaching') {
            program.remarks = ['Aufbaukurs Senior Business Coach']
          }

          if(program.bezeichnung == 'Mediation' ||
             program.bezeichnung == 'Systemischer Business Coach') {
             program.remarks.push('Schnupperkurs')
          }

          return program;
        })

        this.setState({ programs: mappedPrograms })
      }).catch(errors => {
      let state = this.state
      state.failed = true
      this.setState(state)
    })
  }

  loadLocations () {
    fetch('/api/application/locations').
      then(response => response.json()).
      then(locations => {
        locations.sort(function (a, b) {
          if (a.title < b.title) {
            return -1
          }
          if (a.title > b.title) {
            return 1
          }
          return 0
        })
        this.setState({ locations: locations })
      }).catch(errors => {
      let state = this.state
      state.failed = true
      this.setState(state)
    })
  }

  loadDefaultContacts () {
    fetch('/api/application/additional-contacts').
      then(response => response.json()).
      then(contacts => {
        this.setState({ contacts: contacts })
      }).catch(errors => {
      let state = this.state
      state.failed = true
      this.setState(state)
    })
  }

  loadCountries () {
    fetch('/api/application/countries').
      then(response => response.json()).
      then(countries => {
        localStorage.setItem("countries", countries);
        this.setState({ countries: countries })
      }).catch(errors => {
      let state = this.state
      state.failed = true
      this.setState(state)
    })
  }

  render () {
    return (
      <Layout homeUrl="/">
        {(() => {
          if (this.state.failed) {
            return <Error message="error.generic"/>
          } else if (this.state.programs && this.state.locations && this.state.countries && !this.state.finished) {
            return <Application programs={this.state.programs}
                                locations={this.state.locations}
                                contacts={this.state.contacts}
                                countries={this.state.countries} />
          }
        })()}
      </Layout>
    )
  }
}
